export function recordingLinkFieldsFromPin(pin: {
  albumKey?: string | null;
  project?: string | null;
}): { albumKey?: string; project?: string } {
  const albumKey = typeof pin.albumKey === 'string' ? pin.albumKey.trim() : '';
  const project = typeof pin.project === 'string' ? pin.project.trim() : '';
  return {
    ...(albumKey ? { albumKey } : {}),
    ...(project ? { project } : {}),
  };
}
